const FREQUENCIES = [150, 280, 440, 620] as const;

export class AudioFeedback {
  private context: AudioContext | null = null;
  private lastStrokeAt = 0;

  async unlock(): Promise<void> {
    if (!this.context) {
      this.context = new AudioContext();
    }
    if (this.context.state === 'suspended') {
      await this.context.resume();
    }
  }

  playStroke(tool: number): void {
    const now = performance.now();
    if (!this.context || now - this.lastStrokeAt < 75) {
      return;
    }
    this.lastStrokeAt = now;
    this.playTone(FREQUENCIES[tool] ?? FREQUENCIES[0], 0.045, 0.035);
  }

  playMilestone(): void {
    this.playTone(760, 0.16, 0.08);
  }

  vibrate(): void {
    if (typeof navigator.vibrate === 'function') {
      navigator.vibrate(22);
    }
  }

  private playTone(frequency: number, duration: number, volume: number): void {
    if (!this.context || this.context.state !== 'running') {
      return;
    }
    const oscillator = this.context.createOscillator();
    const gain = this.context.createGain();
    const start = this.context.currentTime;
    oscillator.frequency.value = frequency;
    oscillator.type = 'sine';
    gain.gain.setValueAtTime(volume, start);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
    oscillator.connect(gain);
    gain.connect(this.context.destination);
    oscillator.start(start);
    oscillator.stop(start + duration);
  }
}
